import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import MenuIcon from '../../shared/components/icons/MenuIcon';
import CloseIcon from '../../shared/components/icons/CloseIcon';
import CourseOutline from '../course/CourseOutline';
import { INITIAL_COURSE_ID, useCourse } from '../course/useCourse';
import './style/course-navigation.scss';

export const LetureNavigationMenu = ({ courseId: pageCourseId } = {}) => {
  const [isOpen, setIsOpen] = useState(true);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const currentPageId = params.get('pageId');
  const courseId = pageCourseId || params.get('courseId') || params.get('cours') || INITIAL_COURSE_ID;
  const { course, loading, error } = useCourse(courseId);

  return (
    <nav aria-label="Course lessons" className={`course-navigation ${isOpen ? '' : 'course-navigation--collapsed'}`}>
      <div className="course-navigation__header">
        {isOpen && course && <h2>{course.title}</h2>}
        <button type="button" className="course-navigation__toggle" onClick={() => setIsOpen(!isOpen)}
          aria-label={isOpen ? 'Close lesson menu' : 'Open lesson menu'}
          aria-expanded={isOpen} aria-controls="course-navigation-units">
          {isOpen ? <CloseIcon /> : <MenuIcon />}
        </button>
      </div>
      <div id="course-navigation-units" hidden={!isOpen}>
        {loading && <p><output>Loading course…</output></p>}
        {error && <p role="alert">{error}</p>}
        {course && <CourseOutline course={course} courseId={courseId} currentPageId={currentPageId} />}
      </div>
    </nav>
  );
};
